import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

export interface ButtonToggleOptionText {
  label: string;
  value: any;
  checked?: boolean;
  disabled?: boolean;
  routerLink?: string;
}

export interface ButtonToggleOptionIcon {
  icon: string;
  value: any;
  checked?: boolean;
  disabled?: boolean;
  routerLink?: string;
}

@Component({
  selector: 'vfs-button-toggle-group',
  templateUrl: './button-toggle-group.component.html',
  styleUrls: ['./button-toggle-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonToggleGroupComponent {
  @Input() optionsText: ButtonToggleOptionText[];
  @Input() optionsIcon: ButtonToggleOptionIcon[];
  @Output() changeValue = new EventEmitter<any>();

  change(event) {
    this.changeValue.emit(event.value);
  }
}
